import { DeliveryDining } from "@mui/icons-material";

const permits = {
  subheadings: {
    details: "permit details",
    holder: "permit holder information",
    vehicle: "vehicle information",
    refund: "refund payment",
    history: "permit history",
  },
  tabs: {
    details: "details",
    refunds: "refund payment",
    history: "history",
  },
  invite: {
    label: "Permit Invite",
    name: "Permit Holder Name",
    email: "Permit Holder Email",
    phone: "Permit Holder Phone",
    deliveryMethod: "Delivery Method",
  },
  dialogs: {
    invite: {
      send_invite_title: "Send Permit Invitation",
      resend_invite_title: "Resend Permit Invitation",
      send_self_service_link_title: "Send Self-Service Link",
      delivery_method: "Delivery Method",
    },
    approval: {
      approve: "Approve Permit",
      deny: "Deny Permit",
      review: "Review Permit",
      time_left: "This request will be automatically denied on {{date}}",
      pending_transaction: "Pending Transaction",
      hold_text: "Hold for {{amount}} on {{brand}} ending in *{{last4}}",
    },
    revoke: {
      title: "Revoke Permit",
      reason: "Reason",
      button: "Revoke Permit",
    },
  },
  buttons: {
    send_invite: "Send Invite",
    resend_invite: "Resend Invite",
    send_self_service_link: "Send Link",
    refund: "Send Refund",
    wizard: "Import Wizard",
    revoke: "Revoke Permit",
  },
  helpers: {
    refund: "refund will be sent to the original form of payment",
    cancel: "also cancel the permit",
  },
  history_table: {
    status: "Status",
    amount: "Amount",
    payment_method: "Payment Method",
    date: "Date",
    time: "Time",
    transaction_id: "Transaction ID",
    email: "Email",
  },
  permit_portal: {
    agree: "I Understand",
    t_and_c: "Terms and Conditions",
  },
  toasts: {
    no_permit_types: "You must create a permit type before creating a permit",
  },
};

export default permits;
